import { defaultSettings } from "../defaultValues";

import {
  isValidString,
  betCheck,
  numberOfBetsCheck,
  onWinResetCheck,
  onWinPercentCheck,
  onLossResetCheck,
  onLossPercentCheck,
  stopOnProfitCheck,
  stopOnLossCheck,
  musicCheck,
  soundCheck,
  volumeCheck,
} from "../checkerFunctions";

export const stringToObjSettings = (str, minBet, maxBet) => {
  if (!isValidString(str)) return defaultSettings;
  const splitted = str.split(";");

  const betCHECKED = betCheck(splitted[0], minBet, maxBet, defaultSettings.bet);
  const numberOfBetsCHECKED = numberOfBetsCheck(
    splitted[1],
    defaultSettings.auto.numberOfBets
  );
  const onWinResetCHECKED = onWinResetCheck(
    splitted[2] === "true",
    defaultSettings.auto.onWinReset
  );
  const onWinPercentCHECKED = onWinPercentCheck(
    splitted[3],
    defaultSettings.auto.onWinPercent
  );
  const onLossResetCHECKED = onLossResetCheck(
    splitted[4] === "true",
    defaultSettings.auto.onLossReset
  );
  const onLossPercentCHECKED = onLossPercentCheck(
    splitted[5],
    defaultSettings.auto.onLossPercent
  );
  const stopOnProfitCHECKED = stopOnProfitCheck(
    splitted[6],
    defaultSettings.auto.stopOnProfit
  );
  const stopOnLossCHECKED = stopOnLossCheck(
    splitted[7],
    defaultSettings.auto.stopOnLoss
  );
  const musicCHECKED = musicCheck(
    splitted[8] === "true",
    defaultSettings.audio.music
  );
  const soundCHECKED = soundCheck(
    splitted[9] === "true",
    defaultSettings.audio.sound
  );
  const volumeCHECKED = volumeCheck(splitted[10], defaultSettings.audio.volume);

  return {
    bet: betCHECKED,
    auto: {
      numberOfBets: numberOfBetsCHECKED,
      onWinReset: onWinResetCHECKED,
      onWinPercent: onWinPercentCHECKED,
      onLossReset: onLossResetCHECKED,
      onLossPercent: onLossPercentCHECKED,
      stopOnProfit: stopOnProfitCHECKED,
      stopOnLoss: stopOnLossCHECKED,
    },
    audio: {
      music: musicCHECKED,
      sound: soundCHECKED,
      volume: volumeCHECKED,
    },
  };
};
